import { TMAIN_THEMES } from 'modules/learning';
import fit_interview from 'assets/images/pages/framework/consultingIcon/0.webp';
import case_interview from 'assets/images/pages/framework/consultingIcon/1.webp';
import turnaround_strategy from 'assets/images/pages/framework/consultingIcon/2.webp';
import growth_strategy from 'assets/images/pages/framework/consultingIcon/3.webp';
import dd_market_sizing from 'assets/images/pages/framework/consultingIcon/4.webp';
import operation_optimization from 'assets/images/pages/framework/consultingIcon/5.webp';
import sales_marketing_strategy from 'assets/images/pages/framework/consultingIcon/6.webp';
import basic_guide from 'assets/images/pages/framework/financeIcon/1.webp';
import resume_based_questions from 'assets/images/pages/framework/financeIcon/2.webp';
import ib_industry_insights from 'assets/images/pages/framework/financeIcon/3.webp';
import personality_traits from 'assets/images/pages/framework/financeIcon/4.webp';
import commercial_acumen from 'assets/images/pages/framework/financeIcon/5.webp';
import final_questions from 'assets/images/pages/framework/financeIcon/6.webp';

export const CMAIN_THEMES: TMAIN_THEMES[] = [
  {
    id: 0,
    name: 'Fit Interview',
    subtitle: 'Fit Interview 준비 방법에 대한 Guide',
    link: 'fit_interview',
    icon: fit_interview,
    color: '#fd8469',
  },
  {
    id: 1,
    name: 'Case Interview',
    subtitle: 'Case Interview 준비 방법에 대한 Guide',
    link: 'case_interview',
    icon: case_interview,
    color: '#90dfaa',
  },
  {
    id: 2,
    name: 'Turnaround Strategy',
    subtitle: 'Turnaround 케이스 유형 접근 방법에 대한 Guide',
    link: 'turnaround_strategy',
    icon: turnaround_strategy,
    color: '#ffd05c',
  },
  {
    id: 3,
    name: 'Growth Strategy',
    subtitle: 'Growth 케이스 유형 접근 방법에 대한 Guide',
    link: 'growth_strategy',
    icon: growth_strategy,
    color: '#84dbff',
  },
  {
    id: 4,
    name: 'DD & Market Sizing',
    subtitle: 'DD & Mkt sizing 케이스 유형 접근 방법에 대한 Guide',
    link: 'dd_market_sizing',
    icon: dd_market_sizing,
    color: '#fd8469',
  },
  {
    id: 5,
    name: 'Operation Optimization',
    subtitle: '소주제를 적어주세요',
    link: 'operation_optimization',
    icon: operation_optimization,
    color: '#90dfaa',
  },
  {
    id: 6,
    name: 'Sales & Marketing Strategy',
    subtitle: '소주제를 적어주세요',
    link: 'sales_marketing_strategy',
    icon: sales_marketing_strategy,
    color: '#324a5e',
  },
];

export const CFINANCE_THEME: TMAIN_THEMES[] = [
  {
    id: 7,
    name: 'Basic Guide',
    subtitle: '',
    link: 'basic_guide',
    icon: basic_guide,
    color: '#324a5e',
  },
  {
    id: 8,
    name: 'Resume-based Questions',
    subtitle: '',
    link: 'resume_based_questions',
    icon: resume_based_questions,
    color: '#fd8469',
  },
  {
    id: 9,
    name: 'IB Industry Insights',
    subtitle: '',
    link: 'ib_industry_insights',
    icon: ib_industry_insights,
    color: '#324a5e',
  },
  {
    id: 10,
    name: 'Personality Traits',
    subtitle: '',
    link: 'personality_traits',
    icon: personality_traits,
    color: '#ff7058',
  },
  {
    id: 11,
    name: 'Commercial Acumen',
    subtitle: '',
    link: 'commercial_acumen',
    icon: commercial_acumen,
    color: '#55c0eb',
  },
  {
    id: 12,
    name: 'Final Questions',
    subtitle: '',
    link: 'final_questions',
    icon: final_questions,
    color: '#324a5e',
  },
];
